var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34433 3.47085L10.296 6.42835L4.41775 12.4084H1.4585V9.43741L7.34433 3.47085ZM10.071 1.57501C11.2246 1.57501 12.1632 2.5383 12.1632 3.69659C12.1632 4.1917 11.9876 4.67247 11.6694 5.05046L11.653 5.06862L10.8852 5.83918L7.9335 2.88168L8.70428 2.10848C9.09949 1.77206 9.57841 1.57501 10.071 1.57501Z"
  })));
}
export default SvgCommonIconEdit2;